// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM4 6H11V4H4V6ZM13 6H20V4H13V6ZM13.002 10.75H10.998V12.7539H13.002V10.75ZM7.00195 13.75H4.99805V15.7539H7.00195V13.75ZM10.002 13.75H7.99805V15.7539H10.002V13.75ZM13.002 13.75H10.998V15.7539H13.002V13.75ZM16.002 13.75H13.998V15.7539H16.002V13.75ZM19.002 13.75H16.998V15.7539H19.002V13.75ZM13.002 16.75H10.998V18.7539H13.002V16.75Z"}}]};

const TableSplitFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'table-split-filled',
    ref,
    icon: element,
  },
));

TableSplitFilledIcon.displayName = 'TableSplitFilledIcon';

export default TableSplitFilledIcon;
